import { render, staticRenderFns } from "./sm-legend.vue?vue&type=template&id=4a90e061&"
import script from "./sm-legend.vue?vue&type=script&lang=js&"
export * from "./sm-legend.vue?vue&type=script&lang=js&"
import style0 from "./sm-legend.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports